module.exports = __webpack_public_path__ + "img/feature_payment.af2b8954.png";